import { RegistrationV2Action, RegistrationStep } from './types.ts';

export const REGISTRATION_V2_SET_EMAIL = 'REGISTRATION_V2/SET_EMAIL';
export const REGISTRATION_V2_SET_VALIDATED_EMAIL = 'REGISTRATION_V2/SET_VALIDATED_EMAIL';
export const REGISTRATION_V2_SET_STEP = 'REGISTRATION_V2/SET_STEP';
export const REGISTRATION_V2_PRE_REGISTER_START = 'REGISTRATION_V2/PRE_REGISTER_START';
export const REGISTRATION_V2_PRE_REGISTER_SUCCESS = 'REGISTRATION_V2/PRE_REGISTER_SUCCESS';
export const REGISTRATION_V2_PRE_REGISTER_FAIL = 'REGISTRATION_V2/PRE_REGISTER_FAIL';
export const REGISTRATION_V2_CODE_VALIDATION_START = 'REGISTRATION_V2/CODE_VALIDATION_START';
export const REGISTRATION_V2_CODE_VALIDATION_SUCCESS = 'REGISTRATION_V2/CODE_VALIDATION_SUCCESS';
export const REGISTRATION_V2_CODE_VALIDATION_FAIL = 'REGISTRATION_V2/CODE_VALIDATION_FAIL';
export const REGISTRATION_V2_RESEND_CODE_START = 'REGISTRATION_V2/RESEND_CODE_START';
export const REGISTRATION_V2_RESEND_CODE_SUCCESS = 'REGISTRATION_V2/RESEND_CODE_SUCCESS';
export const REGISTRATION_V2_RESEND_CODE_FAIL = 'REGISTRATION_V2/RESEND_CODE_FAIL';
export const REGISTRATION_V2_COMPLETE_REGISTRATION_START = 'REGISTRATION_V2/COMPLETE_REGISTRATION_START';
export const REGISTRATION_V2_COMPLETE_REGISTRATION_SUCCESS = 'REGISTRATION_V2/COMPLETE_REGISTRATION_SUCCESS';
export const REGISTRATION_V2_COMPLETE_REGISTRATION_FAIL = 'REGISTRATION_V2/COMPLETE_REGISTRATION_FAIL';
export const REGISTRATION_V2_SET_SKILLS = 'REGISTRATION_V2/SET_SKILLS';
export const REGISTRATION_V2_CLEAR_FLOW = 'REGISTRATION_V2/CLEAR_FLOW';

export const setEmail = (email: string): RegistrationV2Action => ({
  type: REGISTRATION_V2_SET_EMAIL,
  payload: email,
});

export const setValidatedEmail = (email: string): RegistrationV2Action => ({
  type: REGISTRATION_V2_SET_VALIDATED_EMAIL,
  payload: email,
});

export const setStep = (step: RegistrationStep): RegistrationV2Action => ({
  type: REGISTRATION_V2_SET_STEP,
  payload: step,
});

export const setSkills = (skills: any[]): RegistrationV2Action => ({
  type: REGISTRATION_V2_SET_SKILLS,
  payload: skills,
});

export const clearFlow = (): RegistrationV2Action => ({
  type: REGISTRATION_V2_CLEAR_FLOW,
});
